/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerSpecialCriteria } from './ScreenerSpecialCriteria';
import {
    ScreenerSpecialCriteriaFromJSON,
    ScreenerSpecialCriteriaFromJSONTyped,
    ScreenerSpecialCriteriaToJSON,
} from './ScreenerSpecialCriteria';

/**
 * 
 * @export
 * @interface FindAllSpecialCriteria200Response
 */
export interface FindAllSpecialCriteria200Response {
    /**
     * 
     * @type {Array<ScreenerSpecialCriteria>}
     * @memberof FindAllSpecialCriteria200Response
     */
    data?: Array<ScreenerSpecialCriteria>;
}

/**
 * Check if a given object implements the FindAllSpecialCriteria200Response interface.
 */
export function instanceOfFindAllSpecialCriteria200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllSpecialCriteria200ResponseFromJSON(json: any): FindAllSpecialCriteria200Response {
    return FindAllSpecialCriteria200ResponseFromJSONTyped(json, false);
}

export function FindAllSpecialCriteria200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSpecialCriteria200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ScreenerSpecialCriteriaFromJSON)),
    };
}

export function FindAllSpecialCriteria200ResponseToJSON(value?: FindAllSpecialCriteria200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ScreenerSpecialCriteriaToJSON)),
    };
}

